// File: src/config.js

// This checks your .env file first; if not found, it uses the hardcoded URL
//const API_URL = process.env.REACT_APP_API_URL || "https://pms-server-google-cloud-run-356323743278.asia-south2.run.app";

const API_URL = process.env.REACT_APP_API_URL  || "https://pmsserver.nsfdcdigital.in";
//const API_URL = process.env.REACT_APP_API_URL  || "http://localhost:5112";

export default API_URL;

//https://pmsserver.nsfdcdigital.in
//http://localhost:5112